/**
 * @generated SignedSource<<fad9097d3260a0a478b0de285a661880>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RenameProjectStageInput = {
  id: string;
  name: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type RenameProjectStageMutation$variables = {
  input: RenameProjectStageInput;
};
export type RenameProjectStageMutation$data = {
  readonly renameProjectStage: {
    readonly projectStage: {
      readonly id: string;
      readonly name: string | null;
    } | null;
  } | null;
};
export type RenameProjectStageMutation = {
  variables: RenameProjectStageMutation$variables;
  response: RenameProjectStageMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RenameProjectStageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RenameProjectStagePayload",
        "kind": "LinkedField",
        "name": "renameProjectStage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "projectStage",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RenameProjectStageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RenameProjectStagePayload",
        "kind": "LinkedField",
        "name": "renameProjectStage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "projectStage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "de52e4a56cc6cbc9cdf376d4f1e25c3a",
    "id": null,
    "metadata": {},
    "name": "RenameProjectStageMutation",
    "operationKind": "mutation",
    "text": "mutation RenameProjectStageMutation(\n  $input: RenameProjectStageInput!\n) {\n  renameProjectStage(input: $input) {\n    projectStage {\n      __typename\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "59664d4d962cd709a2bc4898dcb198d6";

export default node;
